import type { MaybeRefOrGetter } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePanel } from '#layers/workspace/public';
import CodePanel from '~/components/CodePanel.vue';

export function useCodePanel(show: MaybeRefOrGetter<boolean> = true) {
	const { t } = useI18n();

	usePanel({
		id: 'code',
		label: t('code_panel.toggle'),
		icon: 'lucide:braces',
		component: CodePanel,
		order: 90,
	}, { enabled: show });
}
